import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import LittleCalendar from '~/components/LittleCalendar'
import { color, device, fontWeight, Pill, SmallText, space, Text } from '@ticketswap/solar'
import { getEventLocation } from '~/utils/eventDescription'
import { Ticket } from '@ticketswap/comets'
import ArtistAvatarCount from '~/components/ArtistAvatarCount'
import { getLinkProps } from '~/utils'
import { decodeGlobalId } from '~/utils/id'
import Link from 'next/link'
import { eventListFragmentPropTypes } from '~/graphql/fragments/eventList'

const StyledArtistAvatarCount = styled(ArtistAvatarCount)`
  background-color: ${color.stardust};

  div {
    border-color: ${color.stardust};
  }
`

const Item = styled.li`
  display: flex;
  align-items: start;
  padding: ${space[16]};
  cursor: pointer;

  :hover {
    background-color: ${color.stardustLight};

    ${StyledArtistAvatarCount} {
      background-color: ${color.nova};

      div {
        border-color: ${color.nova};
      }
    }
  }

  :not(:first-of-type) {
    border-top: 1px solid ${color.spaceLightest};
  }

  // Little calendar shouldn't shrink (should stay a square)
  > div:first-of-type {
    flex-shrink: 0;
  }
`

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
`

const Body = styled.div`
  display: flex;
  align-items: center;
`

const TextContent = styled.div`
  margin: 0 ${space[12]};
  flex-grow: 1;
  overflow: hidden;

  @media ${device.mobileL} {
    margin: 0 ${space[16]};
  }

  span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    :first-of-type {
      font-weight: ${fontWeight.semiBold};
      line-height: 22.5px;
    }

    :nth-of-type(2) {
      color: ${color.spaceMedium};
    }
  }
`

const ArtistWrapper = styled.div`
  display: flex;
  margin-top: ${space[8]};
  margin-left: ${space[12]};

  @media ${device.tablet} {
    margin-left: ${space[16]};
  }
`

const ListItem = ({ t, event, trackClick }) => (
  <Link
    {...getLinkProps('EVENT_PAGE', {
      eventId: decodeGlobalId(event.id),
      eventSlug: event.slug,
    })}
  >
    <Item onClick={() => trackClick && trackClick(decodeGlobalId(event.id))}>
      <LittleCalendar startDate={event.startDate} endDate={event.endDate} />
      <Wrapper>
        <Body>
          <TextContent>
            <Text>{event.name}</Text>
            <SmallText>{getEventLocation(event)}</SmallText>
          </TextContent>
          {event.availableTicketsCount > 0 && (
            <Pill leftAdornment={<Ticket size={16} />}>{event.availableTicketsCount}</Pill>
          )}
        </Body>
        {event.artists?.length > 0 ? (
          <ArtistWrapper>
            <StyledArtistAvatarCount
              t={t}
              avatarsList={event.artists}
              avatarCount={2}
              totalNumber={event.artists.length}
            />
          </ArtistWrapper>
        ) : undefined}
      </Wrapper>
    </Item>
  </Link>
)

ListItem.propTypes = {
  t: PropTypes.func.isRequired,
  event: eventListFragmentPropTypes.isRequired,
  trackClick: PropTypes.func,
}

export default ListItem
